function sendErrorToServer(error) {
   const safeMessage =
      typeof error.message === "string"
         ? error.message.replace(/[\r\n]/g, " ")
         : JSON.stringify(error.message);

   const safeStack = typeof error.stack === "string" ? error.stack.replace(/[\r\n]/g, " ") : JSON.stringify(error.stack);

   fetch("https://appmetrics.loyco.io/api/log", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
         message: `shopify kimanwoman:${safeMessage || "Unknown error"}`,
         source: error.source ?? "N/A",
         lineNumber: error.lineno ?? error.lineNumber ?? null,
         columnNumber: error.colno ?? error.columnNumber ?? null,
         stackTrace: safeStack ?? "N/A",
         url: window.location.href,
         userAgent: navigator.userAgent,
         timestamp: new Date().toISOString(),
      }),
   }).catch((err) => console.log("Failed to send error to server", err));
}

window.onerror = function (message, source, lineno, colno, error) {
   sendErrorToServer({ message, source, lineno, colno, stack: error?.stack });
};

window.addEventListener("unhandledrejection", function (event) {
   sendErrorToServer({ message: event.reason?.message, stack: event.reason?.stack });
});

window.addEventListener(
   "error",
   function (event) {
      if (event.target instanceof HTMLElement) {
         sendErrorToServer({
            message: `Resource Load Error: ${event.target.tagName}`,
            source: event.target.src || event.target.href || "Unknown source",
         });
      }
   },
   true
);
